import { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/** inView per singolo elemento (titoli, label) — start: top 80% */
export default function useGsapInView(ref, start = 'top 80%') {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const ctx = gsap.context(() => {
      const st = ScrollTrigger.create({
        trigger: el,
        start,
        once: true,
        onEnter: () => setInView(true),
        onEnterBack: () => setInView(true),
      });

      requestAnimationFrame(() => {
        if (st.isActive) setInView(true);
      });
    }, el);

    return () => {
      setInView(false);
      ctx.revert();
    };
  }, [ref, start]);

  return inView;
}
